import {DAY_MS, iso, makeShareToken, EUROPE_COUNTRIES, MOCK_ICCID, MOCK_DOMAIN_ID, MOCK_ACTIVATION_CODE, MOCK_RESELLER_INFORMATION} from "./shared";

// "Not installed" demo: the eSIM hasn't been installed on a device yet and its
// package hasn't started counting validity - purchased 2 days ago, 20 days
// left before it would expire unused. Pill/status card show "Ready to
// install" and the profile page offers an "Install eSIM" button.
function dates() {
    return {
        salesDate: iso(-2 * DAY_MS),
        expiresAt: iso(20 * DAY_MS)
    };
}

export function getMockCustomerProfile() {
    const {salesDate, expiresAt} = dates();

    return {
        totalAvailableBalance: {sizeValue: 10, sizeUnit: "GB"},
        balances: [
            {
                price: {priceValue: 14.99, currencyCode: "USD"},
                salesDate,
                customerProfileDomainId: MOCK_DOMAIN_ID,
                includedCountries: EUROPE_COUNTRIES,
                balance: {
                    name: "Europe Data Pack",
                    activatedAt: null,
                    expiresAt,
                    activationMode: "FIRST_USE",
                    size: {sizeValue: 10, sizeUnit: "GB"},
                    availableBalance: {sizeValue: 10, sizeUnit: "GB"},
                    validitySize: 30, validityUnit: "days",
                    countrySet: "eur",
                    extendedDataPolicy: null
                }
            }
        ],
        relatedEsims: [
            {
                uid: "esim-uid-002",
                active: true,
                state: "Released",
                iccid: MOCK_ICCID,
                customerProfileDomainId: MOCK_DOMAIN_ID,
                activatedAt: null,
                lastSeen: null,
                installationUrl: `https://example.com/esim?token=${makeShareToken(MOCK_ICCID)}`,
                appleUniversalLink: "https://example.com/esim/apple-install",
                androidUniversalLink: "https://example.com/esim/android-install",
                activationCode: MOCK_ACTIVATION_CODE,
                imsi: ""
            }
        ],
        resellerInformation: MOCK_RESELLER_INFORMATION
    };
}

// Mocks GET /esim/profile - the data behind the actual "Install eSIM" page
// (ESimInstallation.vue). Describes the exact same eSIM/package as
// getMockCustomerProfile() above, so the numbers a user sees on the profile
// page match what they land on after clicking through.
export function getMockEsimData() {
    const {expiresAt} = dates();

    return {
        esimProfile: {
            uid: "esim-uid-002",
            active: true,
            state: "Released",
            iccid: MOCK_ICCID,
            customerProfileDomainId: MOCK_DOMAIN_ID,
            activatedAt: null,
            lastSeen: null,
            installationUrl: `https://example.com/esim?token=${makeShareToken(MOCK_ICCID)}`,
            appleUniversalLink: "https://example.com/esim/apple-install",
            androidUniversalLink: "https://example.com/esim/android-install",
            activationCode: MOCK_ACTIVATION_CODE,
            imsi: ""
        },
        balances: [
            {
                name: "Europe Data Pack",
                activatedAt: null,
                expiresAt,
                activationMode: "FIRST_USE",
                size: {sizeValue: 10, sizeUnit: "GB"},
                availableBalance: {sizeValue: 10, sizeUnit: "GB"},
                validitySize: 30, validityUnit: "days",
                countrySet: "eur",
                extendedDataPolicy: null
            }
        ],
        totalAvailableBalance: {sizeValue: 10, sizeUnit: "GB"},
        customerProfileUrl: "https://example.com/customer/profile?token=mock-customer-token",
        resellerInformation: MOCK_RESELLER_INFORMATION
    };
}
